import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Collection } from '../../../shared/interfaces/collection.interface'
import { ApiService } from '../../../shared/services/api.service'

@Component({
  selector: 'app-more-dialog',
  templateUrl: './more-dialog.component.html',
  styleUrls: ['./more-dialog.component.scss'],
})
export class MoreDialogComponent implements OnInit {

  dialect = 'CSS'
  visible = false
  cssContent = ''
  iframeSmall = false
  asSVG = false

  @Input() collection: Collection
  @Output() closed = new EventEmitter<any>()

  constructor(private apiService: ApiService) { }

  ngOnInit() {
    setTimeout(() => {
      this.visible = true
    }, 100)
    this.updateCSSContent()
  }

  close() {
    this.visible = false
    setTimeout(() => {
      this.closed.emit()
    }, 300)
  }

  stopClosing(e: Event) {
    e.stopImmediatePropagation()
    e.stopPropagation()
  }

  updateCSSContent() {
    this.apiService.getCSSContent(this.collection.id, this.dialect)
      .subscribe((c: any) => this.cssContent = c)
  }

  get embedCode(): string {
    if (!this.asSVG) {
      return `<iframe src="https://palettes.pxsnake.de/${ this.collection.id }/embed${ this.iframeSmall ? '?small=1' : '' }" width="${ this.iframeSmall ? 500 : 300 }" height="${ this.iframeSmall ? 64 : 500 }" frameBorder="0"></iframe>`
    } else {
      return `<img src="https://palettes.pxsnake.de/${ this.collection.id }/embed.svg${ this.iframeSmall ? '?small=1' : '' }" />`
    }
  }

  get cssLink(): string {
    return `https://palettes.pxsnake.de/${ this.collection.id }/static?lang=${ this.dialect }`
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/collection/containers/more-dialog/more-dialog.component.ts